import { Sport } from '__generated__/globalTypes';
import { Color } from 'style/types';

export const THRESHOLD_COLORS: { [key: string]: Color } = {
  veryLow: 'var(--c-score-veryLow)',
  low: 'var(--c-score-low)',
  mediumLow: 'var(--c-score-mediumLow)',
  medium: 'var(--c-score-medium)',
  mediumHigh: 'var(--c-score-mediumHigh)',
  high: 'var(--c-score-high)',
};

export const nbaThresholds = [
  [4.5, 'veryLow'],
  [14.5, 'low'],
  [24.5, 'mediumLow'],
  [34.5, 'medium'],
  [49.5, 'mediumHigh'],
] as const;

export const mlbThresholds = [
  [2.5, 'veryLow'],
  [7.5, 'low'],
  [11.5, 'mediumLow'],
  [19.5, 'medium'],
  [29.5, 'mediumHigh'],
] as const;

export const NBA_MAX_SCORE = 65;
export const MLB_MAX_SCORE = 45;

export const findThreshold = (score: number, sport: Sport) => {
  const thresholds = sport === Sport.NBA ? nbaThresholds : mlbThresholds;
  const threshold = thresholds.find(t => Number(t[0]) > score);

  return threshold ? threshold[1] : 'high';
};
